var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ma-3",attrs:{"label":"Рабочая область","items":_vm.altWAList,"item-text":"DEPT_NAME","item-value":"DEPT_UUID","value":_vm.value},on:{"input":_vm.sendMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }